import {
    ApplicationProps,
    ConversationProps,
    FriendGroupProps,
    IntimateProps,
    IServiceTextChat,
} from "@obsbot/remo-services";
import { SideEffectManager } from "side-effect-manager";
import { create } from "zustand"; // 修正：从 zustand 导入 create
import { useGlobalStore } from "./global-store";
// @ts-ignore
import _ from "lodash";
import { channelStore } from ".";
export interface InitFriendStoreConfig {
    rtm: IServiceTextChat;
}

export interface FriendItem {
    userID: string;
    remark: string;
    groupList: any[];
    source: string;
    addTime: number;
    friendCustomField: any[];
    timestamp: number;
    profile: Profile;
}

export interface Profile {
    userID: string;
    nick: string;
    gender: string;
    birthday: number;
    location: string;
    selfSignature: string;
    allowType: string;
    language: number;
    avatar: string;
    messageSettings: number;
    adminForbidType: string;
    level: number;
    role: number;
    lastUpdatedTime: number;
    profileCustomField: ProfileCustomField[];
}

export interface ProfileCustomField {
    key: string;
    value: string;
}

export interface FriendStoreState {
    /**
     * 副作用管理
     */
    sideEffect: SideEffectManager;
    /**
     * 用户UUID
     */
    readonly userUUID: string;
    /**
     * 私聊对象UUID
     */
    toUserUUID: string;

    // readonly rtc: IServiceVideoChat | null;
    /**
     * RTM实例 {@link IServiceTextChat}
     */
    readonly rtm: IServiceTextChat | null;
    /**
     * 会话列表在线用户（包含好友与非好友）
     */
    conversationOnline: { [params: string]: string };

    friendList: FriendItem[];
    /**
     * 好友分组列表
     */
    friendGroupList: FriendGroupProps[];

    /**
     * 会话列表
     */
    conversation: ConversationProps;
    /**
     * 本地临时会话列表，用于未发送消息时临时点开的会话列表存储
     * 不使用临时发送消息，因为会影响对面会话列表，无法区分对面是临时会话还是固有会话
     */
    localeConversation: any[];
    /**
     * 好友申请列表
     */
    application: ApplicationProps;

    /**
     * 亲密关系申请列表
     */
    intimate: IntimateProps;
    updateIntimate: (data: IntimateProps) => void;
    /**
     * 获取好友分组列表
     */
    getFriendGroupList: () => Promise<FriendGroupProps[]>;
    /**
     * 添加好友
     * @param addFriend 好友信息
     */
    deleteFriend: (userID: string) => Promise<boolean>;
    /**
     * 获取会话列表
     */
    getConversationList: () => Promise<ConversationProps>;
    deleteConversation: (conversationID: string, clear?: boolean) => Promise<boolean>;
    updateConversation: (
        userID: string,
        nick?: string,
        avatar?: string,
        messageRemindType?: string,
    ) => Promise<void>;
    updateLocaleConversation: (conversationItem: string, type: string) => Promise<void>;
    getFriendList: () => Promise<any[]>;

    updateOnlineList: (list: { [params: string]: string }) => Promise<void>;
    updateApplicationList: ({
        sentRequests,
        receivedRequests,
        unreadCount,
    }: ApplicationProps) => Promise<void>;
    /**
     * 获取好友申请列表
     */
    // getFriendApplicationList: () => Promise<ApplicationProps>;

    /**
     * 初始化
     */
    init: () => Promise<void>;
    /**
     * 初始化仓库
     */
    initStore(config: InitFriendStoreConfig): FriendStoreState;
    /**
     * 销毁操作
     */

    destroy(): Promise<void>;
}

export const useFriendStore = create<FriendStoreState>((set, get) => {
    return {
        sideEffect: new SideEffectManager(),
        userUUID: "",
        toUserUUID: "",
        rtm: null,
        application: {
            sentRequests: [],
            receivedRequests: [],
            unreadCount: 0,
        },
        intimate: {
            sendList: [],
            receiveList: [],
            unreadCount: 0,
        },
        conversationOnline: {},
        friendList: [],
        friendGroupList: [],
        localeConversation: [],
        conversation: {
            conversationList: [],
            isSyncCompleted: false,
        },

        async init() {
            console.log("init Friend Store dddd");
        },
        updateIntimate: (data: IntimateProps): void => {
            set({
                intimate: data,
            });
        },
        getConversationList: async () => {
            const { rtm } = get();
            if (!rtm) {
                throw new Error("Missing rtm instance");
            }
            const conversation = await rtm.getConversationList();
            set({ conversation });
            return conversation;
        },
        deleteConversation: async (conversationID: string, clear?: boolean): Promise<boolean> => {
            const { conversation, rtm, localeConversation } = get();
            const list = [...conversation.conversationList];
            const cur = list.find(item => item.conversationID === conversationID);
            if (cur.tempType) {
                const curIndex = list.findIndex(item => item.conversationID === conversationID);
                const tempLocaleList = localeConversation.filter(
                    item => item.conversationID !== conversationID,
                );
                list.splice(curIndex, 1);
                set({
                    conversation: {
                        conversationList: [...list],
                        isSyncCompleted: conversation.isSyncCompleted,
                    },
                    localeConversation: tempLocaleList,
                });
                return true;
            } else {
                const res = await rtm?.deleteConversation(conversationID, Boolean(clear));
                return Boolean(res);
            }
        },
        updateLocaleConversation: async (conversationItem: any, type: string) => {
            const { localeConversation, conversation } = get();
            if (type === "delete") {
                set({
                    localeConversation: localeConversation.filter(
                        e => e.conversationID === conversationItem.conversationID,
                    ),
                    conversation: {
                        conversationList: conversation.conversationList.filter(
                            e => e.conversationID !== conversationItem.conversationID,
                        ),
                        isSyncCompleted: conversation.isSyncCompleted,
                    },
                });
            } else {
                const curIndex = localeConversation.findIndex(
                    item => item.conversationID === conversationItem.conversationID,
                );
                const tempIndex = conversation.conversationList.findIndex(
                    item => item.conversationID === conversationItem.conversationID,
                );
                if (curIndex !== -1 && tempIndex !== -1) {
                    localeConversation[curIndex] = conversationItem;
                    conversation.conversationList[tempIndex] = conversationItem;
                    set({
                        conversation: {
                            conversationList: [...conversation.conversationList],
                            isSyncCompleted: conversation.isSyncCompleted,
                        },
                        localeConversation: [...localeConversation],
                    });
                }
            }
        },
        updateConversation: async (
            userID: string,
            nick?: string,
            avatar?: string,
            messageRemindType?: string,
        ) => {
            const { conversation, localeConversation } = get();
            const tempConversationID = "C2C" + userID;
            const cur = conversation.conversationList.findIndex(
                item => item.conversationID === tempConversationID,
            );
            const list = [...conversation.conversationList];
            let curLocaleList = [...localeConversation];
            if (cur === -1) {
                const tempConversation = {
                    conversationID: tempConversationID,
                    type: "C2C",
                    unreadCount: 0,
                    tempType: "temp",
                    isPinned: false,
                    userProfile: {
                        userID: userID,
                        nick: nick,
                        avatar: avatar,
                    },
                    messageRemindType: messageRemindType || "AcceptAndNotify",
                    lastMessage: { lastTime: Math.round(new Date().valueOf() / 1000) },
                };
                const unPinConversation = list.findIndex(e => e.isPinned === false); // 找出第一个非置顶的会话
                const replaceIndex = unPinConversation === -1 ? list.length : unPinConversation;
                list.splice(replaceIndex, 0, tempConversation); // 将其添加合适的位置
                curLocaleList = _.uniqBy([tempConversation, ...curLocaleList], "conversationID");
            } else {
                const foundConversation = list.splice(cur, 1); // 移除找到的会话
                curLocaleList = curLocaleList.filter(
                    // 从临时会话移除该会话
                    e => e.conversationID === foundConversation[0].conversationID,
                );
                list.unshift(foundConversation[0]);
            }
            set({
                conversation: {
                    conversationList: [...list],
                    isSyncCompleted: conversation.isSyncCompleted,
                },
                localeConversation: curLocaleList,
                toUserUUID: conversation.conversationList?.[0] || "",
            });
        },
        getFriendList: async () => {
            const { rtm } = get();
            if (!rtm) {
                throw new Error("Missing rtm instance");
            }
            const friends = await rtm.getFriendList();
            console.log("[WEB DEBUG]获取好友列表", friends);
            set({ friendList: friends });
            return friends;
        },

        deleteFriend: async (userID: string) => {
            const { rtm, friendList } = get();
            if (!rtm) {
                throw new Error("Missing rtm instance");
            }
            const result = await rtm.deleteFriend(userID);
            console.log("[WEB DEBUG]删除好友", result);
            set({ friendList: friendList.filter(item => item.userID !== userID) });
            return result;
        },
        // getFriendApplicationList: async () => {
        //     const { rtm } = get();
        //     if (!rtm) {
        //         throw new Error("Missing rtm instance");
        //     }
        //     const list = await rtm.getFriendApplicationList();
        //     set({ application: list });
        //     return list;
        // },
        updateOnlineList: async (list: { [params: string]: string }): Promise<void> => {
            set({
                conversationOnline: list,
            });
        },
        updateApplicationList: async ({
            receivedRequests,
            sentRequests,
            unreadCount,
        }: ApplicationProps): Promise<void> => {
            set({
                application: {
                    sentRequests,
                    receivedRequests,
                    unreadCount,
                },
            });
        },
        getFriendGroupList() {
            const { rtm } = get();
            if (!rtm) {
                console.log("Missing rtm instance getFriendGroupList");
                return Promise.reject([]);
                // throw new Error("Missing rtm instance");
            }
            const list = rtm.getFriendGroupList();
            return Promise.resolve(list);
        },
        initStore: (config: InitFriendStoreConfig) => {
            const globalStore = useGlobalStore.getState();
            if (!globalStore.userInfo?.user_id) {
                throw new Error("Missing user uuid");
            }
            const { sideEffect } = get();
            const rtm = config.rtm;
            set({
                userUUID: globalStore.userInfo?.user_id,
                rtm,
            });
            if (!rtm) {
                throw new Error("Missing rtm instance");
            }
            sideEffect.addDisposer(
                rtm.events.on("sdk-ready", async () => {
                    console.log("RTM SDK is ready, performing initialization...");
                }),
            );
            sideEffect.addDisposer(
                rtm.events.on("sdk-not-ready", () => {
                    console.log("RTM SDK is not ready.");
                    // 处理 SDK 未准备就绪的情况
                }),
            );
            sideEffect.addDisposer(
                rtm.events.on("friend-list-updated", async event => {
                    console.log("[WEB DEBUG 好友列表更新]", event.data);
                    set({ friendList: [...event.data] });
                }),
            );
            sideEffect.addDisposer(
                rtm.events.on("user-status-updated", async event => {
                    console.log("user-status-updated ", event);
                }),
            );
            sideEffect.addDisposer(
                rtm.events.on("friend-group-list-updated", async event => {
                    set({ friendGroupList: event.data });
                }),
            );
            sideEffect.addDisposer(
                rtm.events.on("friend-application-list-updated", async event => {
                    console.log("friend-application-list-updated", event);
                    // set({ application: event });
                }),
            );
            sideEffect.addDisposer(
                rtm.events.on("users-profile-update", async event => {
                    console.log("users-profile-update", event);
                    // getFriendList();
                }),
            );
            sideEffect.addDisposer(
                rtm.events.on("conversation-list-updated", async event => {
                    console.log("[conversation-list-updated] 会话更新", event);
                    const { conversation, localeConversation } = get();
                    let tempList = event;
                    let filteredLocaleConversation = [...localeConversation];
                    if (localeConversation.length > 0) {
                        const eventConversationIDs = new Set(
                            event.map(item => item.conversationID),
                        );

                        // Filter localeConversation to keep only the items whose conversationID is NOT in the event set.
                        filteredLocaleConversation = localeConversation.filter(
                            item => !eventConversationIDs.has(item.conversationID),
                        );

                        tempList = _.sortBy(
                            [...event, ...filteredLocaleConversation],
                            [
                                item => !item.isPinned,
                                item => -_.get(item, "lastMessage.lastTime", 0),
                            ],
                        );
                    }
                    set({
                        conversation: {
                            conversationList: tempList,
                            isSyncCompleted: conversation.isSyncCompleted,
                        },
                        localeConversation: filteredLocaleConversation,
                    });
                }),
            );
            // 处理远端用户进入或退出频道
            sideEffect.addDisposer(
                rtm.events.on("member-leave-or-enter", (roomId: string): void => {
                    const activeChannel = channelStore.activeChannel;
                    if (roomId === activeChannel?.channelUuid) {
                        channelStore.queryChannelNum(roomId);
                    }
                }),
            );

            return { ...get() };
        },
        destroy: async () => {
            get().sideEffect.flushAll();
            set({
                userUUID: "",
                toUserUUID: "",
                rtm: null,
                application: {
                    sentRequests: [],
                    receivedRequests: [],
                    unreadCount: 0,
                },
                intimate: {
                    sendList: [],
                    receiveList: [],
                    unreadCount: 0,
                },
                conversationOnline: {},
                friendList: [],
                friendGroupList: [],
                localeConversation: [],
                conversation: {
                    conversationList: [],
                    isSyncCompleted: false,
                },
            });
        },
    };
});

export const friendStore = useFriendStore.getState();
